import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useSeasonal } from '../lib/useSeasonal';
import { THEMES, Shapes } from '../lib/seasonalThemes';

const Effects = ({ theme }) => {
  const items = useMemo(() => Array.from({ length: 16 }, (_, i) => {
    const spec = theme.particles[i % theme.particles.length];
    const fly = !!spec.fly && i % 3 === 0;
    const p = fly ? spec : theme.particles.find(x => !x.fly) || spec;
    return {
      fly, shape: p.shape, light: !!p.dark,
      left: (i * 37 + 11) % 100,
      size: (p.shape === 'dot' ? 5 : p.shape === 'confetti' ? 9 : 12) + ((i * 7) % 12),
      delay: -((i * 2.3) % 18),
      dur: 12 + ((i * 5) % 12),
      color: p.colors[i % (p.colors.length || 1)],
    };
  }), [theme]);
  return (
    <div data-testid="seasonal-effects" className="sz-effects pointer-events-none fixed inset-0 z-[5] overflow-hidden" aria-hidden="true">
      {items.map((it, i) => {
        const S = Shapes[it.shape];
        return (
          <span key={i} className={`${it.fly ? 'sz-fly' : 'sz-fall'} ${it.light ? 'sz-light' : ''}`}
            style={{ left: `${it.left}%`, width: it.size * (it.fly ? 1.8 : 1), animationDelay: `${it.delay}s`, animationDuration: `${it.dur}s`, color: it.color || undefined }}>
            <S className="w-full h-auto" />
          </span>
        );
      })}
    </div>
  );
};

export const SeasonalTheme = () => {
  const s = useSeasonal();
  const { pathname } = useLocation();
  const key = s?.theme && THEMES[s.theme] && !pathname.startsWith('/admin') ? s.theme : '';
  useEffect(() => {
    const el = document.documentElement;
    if (key) el.dataset.season = key; else delete el.dataset.season;
    return () => { delete el.dataset.season; };
  }, [key]);
  return key && s.effects ? <Effects theme={THEMES[key]} /> : null;
};
